// pages/ControlSchemaPage.jsx
import React from 'react';
import { ArrowLeft, Database, Settings } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const ControlSchemaPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header with Back Button */}
      <div className="mb-8">
        <button
          onClick={() => navigate('/dev-admin')}
          className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 mb-4 transition-colors"
        >
          <ArrowLeft className="h-5 w-5" />
          <span>Back to Dashboard</span>
        </button>
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Schema Management</h1>
        <p className="text-gray-600">Manage database schemas and user data structures</p>
      </div>
      
      {/* Coming Soon Content */}
      <div className="bg-white rounded-lg shadow-md p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-24 w-24 rounded-full bg-blue-100 mb-6">
            <Database className="h-12 w-12 text-blue-600" />
          </div>
          <h3 className="text-2xl font-semibold text-gray-900 mb-4">Schema Management Tools</h3>
          <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
            Advanced schema management features are currently in development. This will include 
            tools for managing database structures, user data models, and field configurations.
          </p>
          <div className="flex justify-center space-x-4">
            <span className="px-4 py-2 bg-yellow-100 text-yellow-800 font-medium rounded-full">
              In Development
            </span>
            <span className="px-4 py-2 bg-blue-100 text-blue-800 font-medium rounded-full">
              Coming Soon
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ControlSchemaPage;
